<template>
    
    <!-- Modal -->
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" :class="clase" role="document">
            <div v-if="content" class="modal-content" v-html="content"></div>
            <div v-else class="modal-content">
                <slot></slot>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                content: '',
            }
        },
        props: {
            autoshow: {required: false, default: false},
            clase: {required: false},
            id: {required: true},
        },
        created() {
            window.Event.$on('modal', this.modalIn);
        },
        mounted() {
            let self = this;

            // Cargar al inicio
            if(this.autoshow){
                this.modalShow(false);
            }
        },
        methods: {
            modalIn(id, url) {
                let self = this;

                // Verificamos ID
                if(id != self.id || !url)
                    return;

                // Cargamos URL
                axios
                    .get(url)
                    .then(response => {
                        self.content = response.data;

                        self.modalShow(false);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            modalShow(fresh = true){
                if(fresh) {
                    this.content = '';
                }

                $('#' + this.id).modal();
            },
            modalCose(){
                this.content = '';

                $('#' + this.id).modal('hide');
            },
            onSubmit(){
                alert("test");
            }
        }
    }
</script>